/**
 * Resolves notification deep links for in-app navigation only.
 * - Relative paths starting with a single `/` are allowed (rejects `//` protocol-relative URLs).
 * - Absolute http(s) URLs are followed only when same-origin; otherwise returns null (no open redirect).
 */
export function getNotificationNavigationTarget(actionUrl: string | null): string | null {
  if (actionUrl == null) return null;
  const trimmed = actionUrl.trim();
  if (!trimmed) return null;

  if (trimmed.startsWith('//')) {
    return null;
  }
  if (trimmed.startsWith('/')) {
    const legacy = /^\/duels\/([^/]+)$/.exec(trimmed);
    if (legacy) {
      return `/duel/${legacy[1]}`;
    }
    return trimmed;
  }

  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }
    if (url.origin !== window.location.origin) {
      return null;
    }
    const legacy = /^\/duels\/([^/]+)$/.exec(url.pathname);
    if (legacy) {
      return `/duel/${legacy[1]}${url.search}${url.hash}`;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
